<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-lists">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Listes communes / Ententes syndicales</p>
        <p class="no-margin dark-gray text-sm">
          Bloc optionnel - Si applicable, renseignez les listes communes présentées lors de l'élection
        </p>
      </div>
    </div>
  </div>


  <div id="information-grid" class="p-20">

    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; border: solid 1px #DCEEFF;"
      class="bg-light-gray radius-10 p-20 mb-20"
      *ngFor="let commonList of commonLists; let i = index; trackBy: trackByIndex">
      <div style="grid-column: 1 / -1;" class="flex content-between align-items-center">
        <p class="light-blue bold">List commune {{i + 1}}</p>
        <img class="pointer" (click)="deleteAt(i)" src="assets/trash-red-icon.svg" alt="trash">
      </div>
      <div>
        <p class="dark-blue no-margin bold">Nom de la liste commune</p>
        <input [(ngModel)]="commonLists[i].listName" (ngModelChange)="onCommonListsChange()" type="text"
          name="commonList-{{i}}" id="commonList-{{i}}" maxlength="14" class="w-full text-md dark-blue pap-input"
          value="{{commonList}}">
      </div>
      <div>
        <p class="dark-blue no-margin bold">Nom des syndicats entrant dans cette liste</p>
        <input [(ngModel)]="commonLists[i].listMembers" (ngModelChange)="onCommonListsChange()" type="text"
          name="commonList-listMembers-{{i}}" id="commonList-listMembers-{{i}}"
          class="w-full text-md dark-blue pap-input" value="{{commonList}}">

      </div>

      <div>
        <p class="dark-blue no-margin bold">Nom des organisations syndicales d'affiliation</p>
        <input [(ngModel)]="commonLists[i].listMembersFullName" (ngModelChange)="onCommonListsChange()" type="text"
          name="commonList-listMembersFullName-{{i}}" id="commonList-listMembersFullName-{{i}}" maxlength="14"
          class="w-full text-md dark-blue pap-input" value="{{commonList}}">
      </div>

      <div>
        <p class="dark-blue no-margin bold">Répartition des suffrages entre organisations (en %)</p>
        <input [(ngModel)]="commonLists[i].composition" (ngModelChange)="validateComposition(i)"
          (wheel)="$event.preventDefault()"
          (keydown)="$event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-' ? $event.preventDefault() : null"
          type="number" name="commonList-composition-{{i}}" id="commonList-composition-{{i}}" pattern="[0-9]*"
          inputmode="numeric" class="w-full text-md dark-blue pap-input" min="0" max="100"
          oninput="if(this.value.length > 3) this.value = this.value.slice(0,3); if(this.value > 100) this.value = 100;">
      </div>
    </div>



    <button *ngIf="commonLists.length < 10" class="w-full p-5 bg-white radius-10 dark-blue bold"
      style="border: solid 1px #E2E8F0; grid-column: 1 / -1;" (click)="addCommonList()">
      + Ajouter une liste commune
    </button>

  </div>
</div>
